<div class="d-flex flex-column min-vh-100 bg-dark">
  <!-- Gridster scrollable area -->
  <div class="gridster-wrapper flex-grow-1 overflow-auto" style="height: calc(100vh - 80px);">
    <gridster [options]="options">
      @for (item of dashboard; track item) {
      <gridster-item [item]="item">
        <!-- OpenUrgent card -->
        @if (item.hasContent && item.contentType === 'OpenUrgent') {
        <div class="gridster-item-content">
          <div class="drag-handler card h-100">
            @if (AtpData.UrgentPaginator) {
            <div class="drag-handler card-body bg-dark text-white rounded-bottom">
              <h4 class="card-title">Openstaande spoedtaxaties ({{AtpData.UrgentPaginator.records}})</h4>
              <div class="col-12">
                <table class="table table-sm table-dark table-hover align-middle text-truncate">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">MMT</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  @if (AtpData.Urgent !== '' && AtpData.UrgentPaginator.records > 0) {
                  <tbody>
                    @for (row of AtpData.Urgent; track row) {
                    <tr [class.bg-danger]="row.isTreated === false">
                      <td>T{{row.id}}</td>
                      <td>{{row.VehicleSpecification.Vehicle.make + ' ' + row.VehicleSpecification.Vehicle.modelSpecific
                        | slice:0:30}}</td>
                      <td>{{row.created.date | date:'HH:mm'}}</td>
                    </tr>
                    }
                  </tbody>
                  }
                  @if (AtpData.UrgentPaginator.records === 0) {
                  <tbody>
                    <tr>
                      <th colspan="3">😄 Er zijn geen spoedtaxaties</th>
                    </tr>
                  </tbody>
                  }
                </table>
              </div>
            </div>
            }
          </div>
        </div>
        }
        <!-- AmountUrgent card -->
        @if (item.hasContent && item.contentType === 'AmountUrgent') {
        <div class="gridster-item-content bg-dark h-100">
          <div class="drag-handler card h-100">
            @if (AtpData.Stock) {
            <div class="drag-handler card-body bg-dark text-white rounded-bottom">
              <h4 class="card-title">Taxaties in bedrijfsvoorraad ({{AtpData.StockPaginator.records}})</h4>
              <div class="row">
                <div class="col-12">
                  <table class="table table-sm table-dark table-hover align-middle text-truncate">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Bedrijfsnaam</th>
                        <th scope="col">MMT</th>
                        <th scope="col">Tijd</th>
                      </tr>
                    </thead>
                    @if (AtpData.StockPaginator.records > 0) {
                    <tbody>
                      @for (row of AtpData.Stock; track row) {
                      <tr>
                        <td>T{{row.id}}</td>
                        <td>{{row.Company.name | slice:0:25}}</td>
                        <td>{{row.VehicleSpecification.Vehicle.make + ' ' +
                          row.VehicleSpecification.Vehicle.modelSpecific | slice:0:20}}</td>
                        <td>{{row.created.date | date:'HH:mm'}}</td>
                      </tr>
                      }
                    </tbody>
                    }
                    @if (AtpData.StockPaginator.records === 0) {
                    <tbody>
                      <tr>
                        <th colspan="4">😄 Er zijn geen taxaties</th>
                      </tr>
                    </tbody>
                    }
                  </table>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
        <!-- ConversionUrgent card -->
        @if (item.hasContent && item.contentType === 'ConversionUrgent') {
        <div class="gridster-item-content d-flex justify-content-center align-items-center">
          <div
            class="drag-handler card-body w-100 h-100 d-flex flex-column justify-content-center align-items-center p-3">
            <div class="row w-100">
              @for (card of getConversionUrgentCards(); track card) {
              <div class="col-md-4">
                <div class="card-counter primary d-flex align-items-center p-3 h-100">
                  <i [class]="card.icon" class="me-3" style="font-size: 4em; opacity: 0.2;"></i>
                  <div class="d-flex flex-column align-items-end w-100">
                    @if (card.value === '') {
                    <div class="count-numbers" id="wave">
                      <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                    </div>
                    }
                    @if (card.value !== '') {
                    <div class="count-numbers">{{ card.value }}</div>
                    }
                    <div class="count-name text-end">{{ card.label }}</div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </gridster-item>
      }
    </gridster>
  </div>

  <!-- Footer stays at bottom -->
  <footer class="page-footer">
    <div class="text-center py-2 small text-light">
      <div class="d-flex justify-content-center align-items-center gap-4">
        <div>
          <i class="Blink fa fa-circle text-danger"></i>&nbsp; LIVE - {{ currentTime | date:'HH:mm:ss'}} Versie: {{
          version }}
        </div>
        <div>
          <button class="btn btn-sm btn-outline-light" (click)="logout()">
            <i class="fas fa-sign-out-alt me-1"></i>Uitloggen
          </button>
        </div>
      </div>
    </div>
  </footer>
</div>